<script setup lang="ts">
const {
  disabled = false,
  error,
  label,
  name,
  type = 'text',
} = defineProps<{
  disabled?: boolean
  error: string | null
  label: string
  name: string
  type?: string
}>()

const emit = defineEmits(['input'])
const model = defineModel()
</script>

<template>
  <div :class="['input-container', { '--error': error }]">
    <label :for="name">{{ label }}</label>
    <input :id="name" v-model="model" :type="type" @input="emit('input')" :disabled="disabled" />
    <p v-if="error" class="input-container__feedback">
      {{ error }}
    </p>
  </div>
</template>
